// 对document.hidden做前缀处理
/* eslint-disable */
function getHiddenProp() {
  var prefixes = ['webkit', 'moz', 'ms', 'o']

  // if 'hidden' is natively supported just return it
  if ('hidden' in document) return 'hidden'

  // otherwise loop over all the known prefixes until we find one
  for (var i = 0; i < prefixes.length; i++) {
    if (prefixes[i] + 'Hidden' in document) return prefixes[i] + 'Hidden'
  }

  // otherwise it's not supported
  return ''
}

// 获取document.visibilityState属性
function getVisibilityState() {
  var prefixes = ['webkit', 'moz', 'ms', 'o']
  if ('visibilityState' in document) return 'visibilityState'
  for (var i = 0; i < prefixes.length; i++) {
    if (prefixes[i] + 'VisibilityState' in document) return prefixes[i] + 'VisibilityState'
  }
  // otherwise it's not supported
  return null
}

const visProp = getHiddenProp()

const evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange'

export default function (cb) {
  const visProp = getHiddenProp()
  if (!visProp) {
    return
  }
  const func = () => {
    if (document[getVisibilityState()] == 'visible') {
      cb(true)
    } else {
      cb(false)
    }
  }
  return {
    on: () => {
      document.addEventListener(evtname, func, false)
    },
    off: () => {
      document.removeEventListener(evtname, func, false)
    }
  }
}
